import React from 'react';

class smartTh extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_241_966)">
          <path
            d="M40 74C58.7777 74 74 58.7777 74 40C74 21.2223 58.7777 6 40 6C21.2223 6 6 21.2223 6 40C6 58.7777 21.2223 74 40 74Z"
            fill="#E4E1DE"
          />
          <path
            d="M69.5481 39.9999C69.5481 23.6819 56.3201 10.4519 40.0001 10.4519C23.6801 10.4519 10.4521 23.6819 10.4521 39.9999H69.5481Z"
            fill="white"
          />
          <path
            d="M69.5481 40C69.5481 56.318 56.3201 69.548 40.0001 69.548C23.6801 69.548 10.4521 56.318 10.4521 40H69.5481Z"
            fill="white"
          />
          <path
            d="M40.0002 5.19995C20.8122 5.19995 5.2002 20.812 5.2002 40C5.2002 59.188 20.8122 74.8 40.0002 74.8C59.1882 74.8 74.8002 59.188 74.8002 40C74.8002 20.812 59.1882 5.19995 40.0002 5.19995ZM40.0002 73.2C21.6942 73.2 6.8002 58.306 6.8002 40C6.8002 21.694 21.6942 6.79995 40.0002 6.79995C58.3062 6.79995 73.2002 21.694 73.2002 40C73.2002 58.306 58.3062 73.2 40.0002 73.2Z"
            fill="#83827F"
          />
          <path
            d="M40.0003 9.65186C23.2663 9.65186 9.65234 23.2659 9.65234 39.9998C9.65234 56.7338 23.2663 70.3478 40.0003 70.3478C56.7343 70.3478 70.3483 56.7338 70.3483 39.9998C70.3483 23.2659 56.7343 9.65186 40.0003 9.65186ZM40.0003 11.2519C55.5843 11.2519 68.3103 23.7179 68.7363 39.1998H11.2643C11.6903 23.7179 24.4163 11.2519 40.0003 11.2519ZM40.0003 68.7478C24.4163 68.7478 11.6903 56.2818 11.2643 40.7998H68.7363C68.3103 56.2818 55.5823 68.7478 40.0003 68.7478Z"
            fill="#83827F"
          />
          <path
            d="M36.0139 47.842C37.6939 47.842 39.0079 49.232 39.0079 50.928C39.0079 52.624 37.6939 54.014 36.0139 54.014C34.3339 54.014 33.0039 52.594 33.0039 50.928C33.0039 49.262 34.3319 47.842 36.0139 47.842ZM36.0139 52.318C36.7319 52.318 37.3279 51.692 37.3279 50.928C37.3279 50.164 36.7319 49.538 36.0139 49.538C35.2959 49.538 34.6999 50.15 34.6999 50.928C34.6999 51.706 35.3099 52.318 36.0139 52.318ZM42.7039 48.026H44.5379L37.4039 59.36H35.6159L42.7039 48.026ZM44.0179 53.28C45.6979 53.28 46.9959 54.67 46.9959 56.366C46.9959 58.062 45.6979 59.452 44.0179 59.452C42.3379 59.452 41.0079 58.032 41.0079 56.366C41.0079 54.7 42.3379 53.28 44.0179 53.28ZM44.0179 57.756C44.7359 57.756 45.3159 57.13 45.3159 56.366C45.3159 55.602 44.7359 54.976 44.0179 54.976C43.2999 54.976 42.6899 55.586 42.6899 56.366C42.6899 57.146 43.2999 57.756 44.0179 57.756Z"
            fill="url(#paint0_linear_241_966)"
          />
          <path
            d="M35.202 22.916C35.202 24.016 34.286 24.916 33.17 24.916C32.054 24.916 31.124 24.014 31.124 22.916C31.124 21.818 32.04 20.854 33.17 20.854C34.3 20.854 35.202 21.77 35.202 22.916ZM33.156 23.68C33.598 23.68 33.95 23.328 33.95 22.902C33.95 22.476 33.598 22.108 33.156 22.108C32.744 22.108 32.376 22.46 32.376 22.902C32.376 23.344 32.742 23.68 33.156 23.68ZM41.098 22.214C42.61 22.214 43.986 22.886 44.962 23.91L43.678 25.33C43.052 24.658 41.906 24.246 40.99 24.246C39.126 24.246 37.538 25.88 37.538 28.004C37.538 30.128 39.126 31.776 40.99 31.776C41.906 31.776 43.052 31.348 43.678 30.692L44.962 32.082C43.984 33.136 42.61 33.808 41.098 33.808C38.028 33.808 35.646 31.15 35.646 28.004C35.646 24.858 38.03 22.216 41.098 22.216V22.214Z"
            fill="url(#paint1_linear_241_966)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_241_966"
            x="3.8002"
            y="3.79995"
            width="75.5996"
            height="75.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolation-filters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_966"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_966"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_966"
            x1="34.9719"
            y1="48.8805"
            x2="42.5275"
            y2="59.3253"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_966"
            x1="33.0704"
            y1="22.0126"
            x2="41.7663"
            y2="32.6681"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}
export default smartTh;
